const REGEX_NOT_DIGITS_AND_DOT = /[^\d.]/g;
const REGEX_PASSWORD_SPECIAL_CHARACTER = /.*[`~<>?,./!@#$%^&*()\-_+="'|{}[\];:\\].*/;

export const LOCATION_MONTHLY_RATE_PARAM = 30;

export const ARTWORK_MAX_FILE_SIZE_BYTES = 30 * 1024 * 1024;
export const ARTWORK_MAX_FILE_SIZE_MB = ARTWORK_MAX_FILE_SIZE_BYTES / (1024 * 1024);

export const activityTypeLabels: Record<string, string> = {
  AIRPORT: 'Airport',
  BUSINESS_CENTER: 'Business center',
  CINEMA: 'Cinema',
  FITNESS_CENTER: 'Fitness center',
  GAS_STATION: 'Gas station',
  HYPERMARKET: 'Hypermarket',
  HOTEL: 'Hotel',
  MEDICAL_CENTER: 'Medical center',
  RESIDENTIAL: 'Residential',
  SPORT: 'Sport',
  SHOPPING_GALLERY: 'Shopping gallery',
  SHOPPING_MALL: 'Shopping mall',
  PUBLIC_TRANSPORT: 'Public transport',
  SUPERMARKET: 'Supermarket',
};

const departments = [
  'Administrative',
  'Financial',
  'Leasing',
  'Management',
  'Marketing',
  'Media Sales',
  'Security',
  'Tehnic',
];

const positions = [
  'ASSET_MANAGER',
  'BOARD_MEMBER',
  'CENTER_MANAGER',
  'CEO',
  'COO',
  'CORPORATE_ADVERTISING_MANAGER',
  'COUNTRY_MANAGER',
  'GENERAL_MANAGER',
  'GROUP_MEDIA_SALES_MANAGER',
  'HEAD_OF_MEDIA_SALES',
];

const activityTypes = [
  'AIRPORT',
  'BUSINESS_CENTER',
  'CINEMA',
  'FITNESS_CENTER',
  'GAS_STATION',
  'HYPERMARKET',
  'HOTEL',
  'MEDICAL_CENTER',
  'RESIDENTIAL',
  'SPORT',
  'SHOPPING_GALLERY',
  'SHOPPING_MALL',
  'PUBLIC_TRANSPORT',
  'SUPERMARKET',
];

const industries = {
  BANKING_FINANCE: 'Banking & Finance',
  BUSINESS_INSURANCE: 'Business & Insurance',
  CLOTHING_ACCESSORIES: 'Clothing & Accessories',
  COSMETICS_TOILETRIES: 'Cosmetics & Toiletries',
  DRINKS: 'Drinks',
  ECOMMERCE: 'eCommerce',
  FOOD: 'Food',
  HOUSEHOLD_CARE: 'Household Care',
  HOUSEHOLD_EQUIPMENT_APPLIANCES: 'Household Equipment & Appliances',
  LEISURE_ENTERTAINMENT_TIME: 'Leisure & Entertainment Time',
  MOTORS_VEHICLES: 'Motors & Vehicles',
  PERSONAL_HYGIENE: 'Personal Hygiene',
  PET_CARE: 'Pet care',
  PHARMACEUTICAL_HEALTH: 'Pharmaceutical/Health',
  RETAIL: 'Retail',
  SOCIAL_GOVT: 'Social & GOVT',
  SPORTS_APPAREL: 'Sports Apparel',
  SPORTS_FACILITIES: 'Sports facilities',
  TELECOM_GADGETS: 'Telecom & Gadgets',
  TOBACCO_IND: 'Tobacco Ind.',
  TRAVEL_TRANSPORT: 'Travel & Transport',
  JEWELRY_ACCESSORIES: 'Jewelry & Accessories',
  MISCELLANEOUS: 'Miscellaneous',
  OTHER: 'Other',
};

export const DEFAULT_PAGINATION_OPTIONS = [10, 20, 50];
export const INITIAL_PAGINATION_MODEL = {
  pageSize: DEFAULT_PAGINATION_OPTIONS[1],
  page: 0,
};

export {
  departments,
  positions,
  activityTypes,
  REGEX_NOT_DIGITS_AND_DOT,
  REGEX_PASSWORD_SPECIAL_CHARACTER,
  industries,
};

export const CURRENCY_SYMBOL = '€';

export const DAYS_OF_WEEK = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
] as const;

export const DAY_ABBREVIATIONS: Record<string, string> = {
  Monday: 'M',
  Tuesday: 'T',
  Wednesday: 'W',
  Thursday: 'T',
  Friday: 'F',
  Saturday: 'S',
  Sunday: 'S',
};
